<template>
  <div class="monitor-wrap">
    <!-- 顶部栏 -->
    <div class="top-bar">
      <div class="top-left">
        <span class="top-tag"><img src="../assets/img/start-top.png" alt=""> {{ form.state === 0 ? '待机' : form.state === 1 ? '运行中' : '未开机' }}</span>
      </div>
      <div class="top-right">
        <span class="real-time"><img src="../assets/img/time-top.png" alt="">{{ form.date }}</span>
      </div>
    </div>

    <!-- 主网格区域 -->
    <div class="grid-container">
      <!-- 左上：设备信息 -->
      <div class="grid-card card-1">
        <div class="card-title">设备信息</div>
        <div class="device-name">
          {{ form.name }}
        </div>
      </div>

      <!-- 右上：水箱数据 -->
      <div class="grid-card card-2">
        <div class="card-title">水箱数据</div>
        <div class="water-row">
          <div class="water-item">
            <div class="item-label"><img src="@/assets/img/c-ddl.png"  alt="">电导率</div>
            <div class="item-num blue">{{ form.state !== -2 ? (form.ddl ? form.ddl : '-') : '-' }}</div>
          </div>
          <div class="split-line"></div>
          <div class="water-item">
            <div class="item-label"><img src="@/assets/img/c-ph.png"  alt="">PH值</div>
            <div class="item-num green">{{ form.state !== -2 ?( form.ph ? form.ph : '-') : '-' }}</div>
          </div>
          <div class="split-line"></div>
          <div class="water-item">
            <div class="item-label"><img src="@/assets/img/c-sw.png"  alt="">水温</div>
            <div class="item-num orange">{{ form.state !== -2 ? (form.wd ? form.wd : '-') : '-' }}</div>
          </div>
        </div>
      </div>

      <!-- 左下：机台负责人 -->
      <div class="grid-card card-3">
        <div class="card-title">机台负责人</div>
        <div class="person-text">{{ form.person ? form.person : '-' }}</div>
      </div>

      <!-- 中下：室内温度 -->
      <div class="grid-card card-4">
        <div class="card-title">室内温度</div>
        <div class="env-row" style="margin: auto 0">
          <div class="env-num blue"><div class="item-label"><img  src="@/assets/img/c-wd.png"  alt=""></div> <daiv>{{ form.state !== -2 ? (form.temperature ? form.temperature : '-' ) : '-'}}</daiv></div>
        </div>
      </div>

      <!-- 右下：室内湿度 -->
      <div class="grid-card card-5">
        <div class="card-title">室内湿度</div>
        <div class="env-row" style="margin: auto 0">
          <div class="env-num blue"><div class="item-label"><img  src="@/assets/img/c-sd.png"  alt=""></div><diav>{{ form.state !== -2 ? (form.humidity ? form.humidity : '-') : '-' }}</diav></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/api";
export default {
  name: 'PrintMachineNew',
  data() {
    return {
      form: {
        date: ''
      },
      timer: null, // 定时器
      timerData: null,   // 接口刷新定时器
      lastDateTime: 0    // 接口返回的时间戳（毫秒）
    }
  },
  mounted() {
    this.getDaPingJiTaiYuTong()
    this.timerData = setInterval(() => {
      this.getDaPingJiTaiYuTong()
    }, 10000) // 10 秒
    // 每秒刷新一次时间
    this.timer = setInterval(() => {
      this.addOneSecond()
    }, 1000)


  },
  beforeDestroy() {
    clearInterval(this.timer)
    clearInterval(this.timerData)
  },
  // created() {
  //   this.currentTime()
  // },
  methods: {
    getDaPingJiTaiYuTong() {
      console.log(this.$route.query.deviceId)
      API.DaPingJiTaiYuTong({deviceId: this.$route.query.deviceId}).then(res => {
        console.log(res)
        this.form = res.message.data
        console.log(this.form)
        if (this.form.date) {
          this.lastDateTime = new Date(this.form.date).getTime()
        }
      })
    },
    // 每秒 +1 秒并格式化
    addOneSecond() {
      if (!this.lastDateTime) return
      // 加 1000 毫秒
      this.lastDateTime += 1000
      // 格式化为 2026-06-13 15:09:36
      this.form.date = this.formatDate(new Date(this.lastDateTime))
    },

    // 日期格式化
    formatDate(date) {
      const y = date.getFullYear()
      const m = this.addZero(date.getMonth() + 1)
      const d = this.addZero(date.getDate())
      const h = this.addZero(date.getHours())
      const min = this.addZero(date.getMinutes())
      const s = this.addZero(date.getSeconds())
      return `${y}-${m}-${d} ${h}:${min}:${s}`
    },

    // 补零
    addZero(num) {
      return num < 10 ? '0' + num : num
    },
    currentTime(){
      setInterval(()=>{
        this.getDaPingJiTaiYuTong()
      },10000)
    },
  }
}
</script>

<style scoped lang="scss">
$bg-light: #e6f0ff;
$main-blue: #1677ff;
$green: #36c759;
$orange: #ff7d00;
$border: #c9e0fb;

.monitor-wrap {
  width: 100%;
  height: 100vh;
  //background: linear-gradient(180deg, #f0f7ff 0%, #e8f2ff 100%);
  padding: 20px;
  box-sizing: border-box;
  overflow-y: auto;
  z-index: 0;
  background-image: url("~@/assets/img/bg-l.png") ;
  background-size: 100% 30%;
  background-repeat: no-repeat;
}

// 顶部栏
.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  //background-image: url("~@/assets/img/bg-l.png");
  background-size: 100% 300%;
  //position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  padding: 0px 20px;
  .top-tag {
    font-size: 32px;
    color: #222;
    img {
      width: 24px;
      margin-right: 5px;
    }
  }
  .top-right {
    font-size: 32px;
    color: #333;
    .time-icon {
      margin-right: 10px;
    }
    img {
      width: 24px;
      margin-right: 10px;
    }
  }
}

// 网格布局
.grid-container {
  margin-top: 0px;
  display: grid;
  padding:  0 20px 20px;
  grid-template-columns: 1.5fr 2fr;
  grid-template-rows: auto auto;
  gap: 16px;
  grid-template-areas:
    "card1 card2"
    "card3 card4 card5";
  grid-template-columns: 1.5fr 1fr 1fr;
  grid-template-areas:
    "card1 card2 card2"
    "card3 card4 card5";
  z-index: 99;
  position: relative;
}

.grid-card {
  border: 1px solid #fff;
  border-radius: 8px;
  padding: 30px;
  box-sizing: border-box;
  background: linear-gradient(180deg, #d7e8ff 0%, #f0f5fb 100%), linear-gradient(180deg, #c6deff 0%, #f2f7fe 100%);
  box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.1);
  .card-title {
    font-size: 40px;
    color: #051856;
    position: relative;
    margin-bottom: 40px;
    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: -8px;
      width: 75px;
      height: 4px;
      background: linear-gradient(90deg, #0072f9 0%, #82bffe 100%);
      border-radius: 2px;
    }
  }
}

// 1.设备信息
.card-1 {
  grid-area: card1;
  .device-name {
    font-size: 100px;
    font-weight: bold;
    color: $main-blue;
    line-height: 1.2;
    text-align: center;
  }
}

// 2.水箱数据
.card-2 {
  grid-area: card2;
  .water-row {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    gap: 10px;
    .split-line {
      width: 2px;
      height: 200px;
      background: #c0d6f0;
    }
    .water-item {
      flex: 1;
      text-align: center;
      .item-icon {
        width: 70px;
        height: 70px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 32px;
        margin: 0 auto 16px;
        &.blue {
          border: 2px solid $main-blue;
          color: $main-blue;
        }
        &.green {
          border: 2px solid $green;
          color: $green;
        }
        &.orange {
          border: 2px solid $orange;
          color: $orange;
        }
      }
      .item-label {
        font-size: 40px;
        color: #333;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
          width: 80px;
          margin-right: 20px;
        }
      }
      .item-num {
        font-size: 150px;
        font-weight: bold;
        line-height: 2;
        &.blue {
          color: $main-blue;
        }
        &.green {
          color: $green;
        }
        &.orange {
          color: $orange;
        }
      }
    }
  }
}

// 3.负责人
.card-3 {
  grid-area: card3;
  .person-text {
    font-size:80px;
    font-weight: bold;
    color: $main-blue;
    text-align: center;
    line-height: 1.5;
  }
}

// 4.温度
.card-4 {
  grid-area: card4;
  .env-row {
    text-align: center;
    gap: 20px;
    .env-icon {
      width: 70px;
      height: 70px;
      border-radius: 50%;
      border: 2px solid $main-blue;
      color: $main-blue;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 32px;
    }
    .env-num {
      font-size: 100px;
      font-weight: bold;
      color: $main-blue;
      //line-height: 2;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 60px;
      img{
        width: 120px;
        margin-right: 30px;
        margin-top: 30px;
        margin-bottom: 20px;
      }
    }
  }
}

// 5.湿度
.card-5 {
  grid-area: card5;
  .env-row {
    //display: flex;
    align-items: center;
    text-align: center;
    gap: 20px;
    .env-icon {
      width: 70px;
      height: 70px;
      border-radius: 50%;
      border: 2px solid $main-blue;
      color: $main-blue;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 32px;
    }
    .env-num {
      font-size: 100px;
      font-weight: bold;
      color: $main-blue;
      //line-height: 2;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 60px;
      img{
        width: 120px;
        margin-right: 30px;
        margin-top: 30px;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
